import { getCurrentJob } from "../../storage";

const current_job = getCurrentJob();

const menuItem = (name, icon, to) => ({
    heder: "",
    list: [{ name, icon, to }],
});

// Base menu items
const baseMenu = [
    menuItem("Home", "home", "/home"),
    menuItem("Jobs", "work", "/jobs/list"),
    menuItem("Jobs requests", "person_raised_hand", "/ftm/request/list"),
    menuItem("Future Jobs", "work_history", "/future/jobs/list"),
    menuItem("My disputes", "mood_bad", "/jobs/disputes/list"),
    menuItem("My Profile", "person", "/profile"),
    menuItem("Payments", "money", "/payments"),
];

// Conditionally include last job section
const lastJobsSection = current_job
    ? [menuItem("Last jobs", "last_page", `/current/job/${current_job.job_id}`)]
    : [];

// Combine all menu items
export const data = [...baseMenu, ...lastJobsSection];